module.exports = __webpack_public_path__ + "static/karshni-38aab7ee7132c8ba8941d431336a1b40.jpg";